import { useMemo } from 'react';
import locales, { Translations, TranslationKey } from '../translations';

function resolveLocale(): string {
    const params = new URLSearchParams(window.location.search);
    const paramLocale = params.get('locale');
    if (paramLocale && locales[paramLocale]) {
        return paramLocale;
    }

    const browserLang = navigator.language?.replace('-', '_');
    if (browserLang && locales[browserLang]) {
        return browserLang;
    }

    const langPrefix = browserLang?.split('_')[0];
    const match = Object.keys(locales).find((key) => key.startsWith(langPrefix + '_'));
    if (match) {
        return match;
    }

    return 'en_US';
}

export function useTranslation(): { t: (key: TranslationKey) => string; locale: string } {
    const locale = useMemo(() => resolveLocale(), []);
    const translations: Translations = locales[locale] || locales['en_US'];

    const t = (key: TranslationKey): string => translations[key] || locales['en_US'][key] || key;

    return { t, locale };
}
